import licenseModule from '../../license.module';

export default licenseModule.component('licenseConsoleNewServerSubscription', {
    template: require('./licenseConsoleNewServerSubscription.component.html'),
    controller: [
        'entitlementConstants',
        licenseConsoleNewServerSubscriptionComponent
    ],
    bindings: {
        summaryDeviceIdTotal: '<',
        summaryPremiumUserIdTotal: '<',
        summaryDeviceIdUsage: '<',
        summaryPremiumUserIdUsage: '<',
        licenseMaxDevices: '<',
        licenseMaxUsers: '<',
        callback: '&'
    }
});

function licenseConsoleNewServerSubscriptionComponent(entitlementConstants) {
    var vm = this;
    vm.devicesLabel = entitlementConstants.devices;
    vm.platformUsersLabel = entitlementConstants.platformUsers;

    var newMaxusers = 0;
    var newMaxDevices = 0;

    vm.$onInit = function() {
        vm.licenseMaxDevices = 0;
        vm.licenseMaxUsers = 0;
        vm.min = 1;
    };

    vm.changes = function() {
        if (
            (vm.licenseMaxUsers !== undefined &&
                vm.licenseMaxUsers != newMaxusers) ||
            (vm.licenseMaxDevices !== undefined &&
                vm.licenseMaxDevices != newMaxDevices &&
                vm.licenseMaxDevices >= 0)
        ) {
            newMaxusers = vm.licenseMaxUsers;
            newMaxDevices = vm.licenseMaxDevices;

            var value = {
                license: {
                    maxUsers: vm.licenseMaxUsers,
                    maxDevices: vm.licenseMaxDevices
                }
            };
            vm.callback({ value: value });
        }
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-console-new-server-subscription/licenseConsoleNewServerSubscription.component.js